import { render, staticRenderFns } from "./drawer-flex-events.vue?vue&type=template&id=170a5ad4&scoped=true&"
import script from "./drawer-flex-events.vue?vue&type=script&lang=js&"
export * from "./drawer-flex-events.vue?vue&type=script&lang=js&"
import style0 from "./drawer-flex-events.vue?vue&type=style&index=0&id=170a5ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a5ad4",
  null
  
)

export default component.exports